import React from 'react';

export default function PrimaryButton({ children, onClick, type = 'button', disabled, variant = 'primary', className = '', ...rest }) {
  const base = 'inline-flex items-center justify-center gap-2 min-h-11 px-5 rounded-full font-medium text-base transition active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none';
  const styles = variant === 'primary'
    ? 'bg-garden-primary text-white hover:bg-garden-primaryDark'
    : variant === 'secondary'
      ? 'bg-white text-garden-ink border border-garden-ink/15 hover:border-garden-ink/30'
      : 'bg-garden-primaryLight text-garden-primaryDark hover:bg-garden-primaryLight/80';
  return (
    <button type={type} onClick={onClick} disabled={disabled} className={`${base} ${styles} ${className}`} {...rest}>
      {children}
    </button>
  );
}
